import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Cluster } from "../models/cluster"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ClusterService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'cluster/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllClusters(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Cluster>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllClusters?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewCluster(ClusterID?: string): Observable<Array<Cluster>> {
    return this.httpService.get(this.apiEndpoint + 'viewCluster/' + (ClusterID ? ClusterID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveCluster(locations: Cluster): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveCluster/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteCluster(ClusterID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteCluster/' + (ClusterID ? ClusterID : '00000000-0000-0000-0000-000000000000'), ClusterID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  checkDuplication(ClusterId?: string, Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&ClusterId=' + (ClusterId ? ClusterId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
  checkEmail(Emailid?: string,ClusterId?: string): Observable<any> { 
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&ClusterId=' + (ClusterId ? ClusterId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
